module.exports = __webpack_public_path__ + "assets/2d4d0225147323ff5997c20c89050ee7.svg";